import Component from "@ember/component"

export default class Outline extends Component {}
